import { GET_ALL_ADMIN_WALLET_DATA_SUCCCESS, GET_ALL_NAVISION_DATA_ERROR, GET_ALL_WALLET_REFUND_DATA_SUCCCESS } from "../actionTypes";

export const navisionInitialState = {
  error: null,
  admin_wallet: [],
  wallet_refund: []
}


export default (state = navisionInitialState , action) => {
  switch (action.type) {
    case GET_ALL_ADMIN_WALLET_DATA_SUCCCESS:
      return {
        ...state,
        admin_wallet: action.payload,
        error: null,
      };
    case GET_ALL_WALLET_REFUND_DATA_SUCCCESS:
      return {
        ...state,
        wallet_refund: action.payload,
        error: null,
      };
    case GET_ALL_NAVISION_DATA_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
